import { z } from 'zod';
export const US_IANA_TIMEZONE_OPTIONS = [
    { id: 'Pacific/Honolulu', label: 'Hawaii' },
    { id: 'America/Anchorage', label: 'Alaska' },
    { id: 'America/Los_Angeles', label: 'Pacific' },
    { id: 'America/Phoenix', label: 'Arizona (no daylight saving)' },
    { id: 'America/Denver', label: 'Mountain' },
    { id: 'America/Chicago', label: 'Central' },
    { id: 'America/New_York', label: 'Eastern' },
];
/**
 * Matches the Retell agent API default when timezone is unset (see retell-sdk AgentResponse), so
 * resolved behavior is unchanged for businesses that have not configured one. Used only where a
 * concrete timezone is mandatory (Retell config, analytics bucketing); business-hours evaluation
 * stays honest about an unset timezone via TIMEZONE_NOT_CONFIGURED.
 */
export const DEFAULT_BUSINESS_TIMEZONE = 'America/Los_Angeles';
const IANA_TIMEZONE_IDS = new Set(Intl.supportedValuesOf('timeZone'));
export const ianaTimezoneSchema = z.string().refine(id => IANA_TIMEZONE_IDS.has(id), {
    message: 'Invalid IANA timezone',
});
/** Normalize DB/nullable value to a valid IANA id for API + Retell (unknown values → default). */
export function resolveBusinessTimezone(stored) {
    const trimmedTimezone = stored?.trim();
    if (trimmedTimezone && IANA_TIMEZONE_IDS.has(trimmedTimezone)) {
        return trimmedTimezone;
    }
    return DEFAULT_BUSINESS_TIMEZONE;
}
//# sourceMappingURL=us-iana-timezone-options.js.map